import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-question-buttons',
  templateUrl: './question-buttons.component.html',
  styleUrls: ['./question-buttons.component.scss']
})
export class QuestionButtonsComponent implements OnInit {

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) {
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }    
   }

  ngOnInit() {
  }

  

  
}